const TINTS = ["teal", "violet", "green", "lime", "rose", "orange", "yellow", "blue", "pink"] as const;

/** A stable tint for a name, so a profile keeps its colour everywhere. */
export function tintOf(name: string): (typeof TINTS)[number] {
	let hash = 0;
	for (const ch of name) hash = (hash * 31 + ch.codePointAt(0)!) >>> 0;
	return TINTS[hash % TINTS.length]!;
}

/** A round initial in the name's tint. */
export function Avatar({ name, size = 40, className }: { name: string; size?: number; className?: string }) {
	const initial = [...name.trim()][0]?.toUpperCase() ?? "?";
	return (
		<span
			className={`avatar tint-${tintOf(name)}${className ? ` ${className}` : ""}`}
			style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }}
			aria-hidden="true"
		>
			{initial}
		</span>
	);
}
